<template>
<div id="nav-header-box" class="clearfix">
    <!-- navIndex!=0 ? -->
    <nav class="navbar navbar-light fixed-top" :style="{borderBottom: '1px solid #999999'}">
        <div class="nav-box">
            <ul class="nav justify-content-end">
                <li v-for="(item,key) in navData" :key="key" :class="['nav-item','px-md-4',item.index == navIndex? 'active': '']" >
                    <a class="nav-link"><router-link :to="item.path">{{item.name}}</router-link>
                        <ul v-if="item.children" class="nav-children-box">
                            <li v-for="(value,index) in item.children" :key="index" @click="goChildren(item.path,value.query,$event)">{{value.name}}</li>
                            <div class="nav-bg-box"></div>
                        </ul>
                    </a>
                </li>
                <li class="nav-phone-box">0512-67570907<span style="margin-left: 25px;">18626295227</span></li>
            </ul>
        </div>
        <router-link :class="{'navbar-brand': true, 'top-brand': topPic}" to="/">
            <!-- width="160" height="200" -->
            <img :src="!topPic?require('../../public/images/logo2.png'):require('../../public/images/logo.png')" class="d-inline-block align-top" alt="" loading="lazy">
        </router-link>
    </nav>
</div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    name: "",
    data() {
        return {
            topPic: true,
            navData: [
                {
                    name: "首页",
                    path: "/",
                    index: 0,
                },
                {
                    name: "时差臻品",
                    path: "/impress",
                    index: 1,
                },
                {
                    name: "精选案例",
                    path: "/case",
                    index: 2,
                    children: [
                        {
                            name: "主题空间",
                            query: {
                                type: 1
                            }
                        },
                        {
                            name: "品牌形象",
                            query: {
                                type: 2
                            }
                        },
                        {
                            name: "样本画册",
                            query: {
                                type: 3
                            }
                        }
                    ]
                },
                // {
                //     name: "关于我们",
                //     path: "/about",
                //     index: 3,
                // },
                {
                    name: "时差动态",
                    path: "/news",
                    index: 4,
                },
                {
                    name: "招贤纳士",
                    path: "/like",
                    index: 5,
                }
            ]
        }
    },
    computed: {
        ...mapState(['navIndex'])
    },
    methods: {
        /**
         * @desc 跳转路由
         */
        goChildren(path,query,event) {
            event.stopPropagation();
            this.$router.push({
                path,
                query
            })
        }
    },
    mounted() {
        window.addEventListener('scroll', (e) => {
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

            if (scrollTop > 500) {
                this.topPic = false;
            } else {
                this.topPic = true;
            }

        })
    }
}
</script>
<style lang="scss" scoped>
#nav-header-box {
    .fixed-top {
        padding: 0;

        .nav-box {
            width: 100%;
            height: 80px;
            background: #ffffff;

            .nav {
                height: 100%;
                align-items: center;
                padding-right: 70px;

                .nav-link {
                    font-size: 18px;
                    padding: 0;
                    position: relative;
                    height: 30px;

                    a {
                        color: #333333;
                        text-decoration: none;
                    }

                    .nav-children-box {
                        height: 0;
                        transition: height 0.5s linear;
                        position: absolute; 
                        top: 60px;
                        width: 100%;
                        list-style: none;
                        padding: 0px;
                        color: #ccc;
                        font-size: 14px;
                        overflow: hidden;
                        width: 120px;
                        left: -35%;

                        li {
                            height: 30px;
                            line-height: 30px;
                            width: 100%;
                            box-sizing: border-box;
                            margin-top: 10px;
                            cursor: pointer;

                            &:hover {
                                border: 1px solid #666666;
                            }
                        }
                    }

                    .nav-bg-box {
                        width: 100%;
                        height: 0;
                        background: rgba(0, 0, 0, 0.5);
                        position: fixed;
                        top: 80px;
                        left: 0px;
                        z-index: -10;
                        transition: height 0.5s linear;
                    }

                    &:hover {
                        border-bottom: 3px solid #cc0000; 

                        .nav-children-box {
                            height: 120px;
                        }

                        .nav-bg-box {
                            height: 150px;
                        }
                    }
                }

                .active {
                    .nav-link {
                        border-bottom: 3px solid #cc0000; 
                    }
                }

                .nav-phone-box {
                    padding-left: 60px;
                    background: url('../../public/images/phone.png') 30px center no-repeat;
                    background-size:  19px 24px;
                }
            }
        }
    }
    .navbar-toggler {
        border: 0px;
    }

    .navbar-brand {
        position: absolute;
        left: 175px;
        top: 50%;
        transform: translateY(-50%);
    }

    .top-brand {
        top: 90px;
    }
}
</style>